import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    funds: 'Funds:',
    tokenAmount: '{amount} {token}',
  },
};
